import PropTypes from "prop-types";
import { Link } from "react-router-dom";

StepProgreassBar.propTypes = {
    title: PropTypes.string.isRequired,
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            completed: PropTypes.bool,
            current: PropTypes.bool,
            path: PropTypes.string,
            disabled: PropTypes.bool
        })
    ).isRequired
}

function StepProgreassBar({ title, steps }) {

    return (
        <div className="title-bar">
            <div className="container-xl">
                <div className="row">
                    <div className="col-12">
                        <h1 className="type-24 mt-4 mb-4">{title}</h1>
                        <ul className="wizard-list hide-noncurrent-mobile horizontal mb-5">
                            {steps.map((step, i) => {
                                let state = "state-future"

                                if (step.current) {
                                    state = "state-current";
                                }
                                else if (step.completed) {
                                    state = "state-complete";
                                }

                                return (
                                    !step.disabled && (
                                        <li key={step.id} className={`wizard-step ${state}`}>
                                            <span className="wizard-step-icon"></span>
                                            <span className="wizard-step-label">
                                                {step.path === undefined || step.path === "" ? (
                                                    step.label
                                                ) : (
                                                    <Link to={step.path}>{step.label} </Link>
                                                )}
                                            </span>
                                        </li>
                                    )
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StepProgreassBar;